// removed by extract-text-webpack-plugin
module.exports = {"Footer":"Footer__Footer__268PT","FooterBlock":"Footer__FooterBlock__3ZkpP","FooterText":"Footer__FooterText__GRIQr","FooterAvatar":"Footer__FooterAvatar__1bVnN","active":"Footer__active__2RPGs","Avatar":"Footer__Avatar__1Xuvv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.css
// module id = 57
// module chunks = 0